<template>
  <div class="property-wrap">
    <div class="page-header">
      <el-select class="select-item" v-model="filterData.advertiserIds" filterable :filter-method="filterCount">
        <el-option label="全部广告账号" :value="-1"> </el-option>
        <el-option
          v-for="item of countList"
          :key="item.advertiserId"
          :value="item.advertiserId"
          :label="item.company + '-' + item.advertiserId"
        ></el-option>
      </el-select>
      <el-select class="select-item" v-model="filterData.status">
        <el-option label="全部接入状态" :value="-1"> </el-option>
        <el-option :label="item.label" v-for="item in accessStatusList" :key="item.value" :value="item.value"> </el-option>
      </el-select>
      <el-input
        class="select-item"
        suffix-icon="el-icon-search"
        style="width: 300px"
        v-model="filterData.search"
        placeholder="请输入转化归因"
      />
      <el-button class="header-btn" @click="resetFilter" style="margin-left: auto">重置</el-button>
      <el-button class="header-btn" @click="searchData" type="primary">查询</el-button>
    </div>
    <div class="page-content">
      <div class="btn-list">
        <el-button class="btn-item" icon="el-icon-plus" type="primary" @click="addTransform">新增应用转化</el-button>
        <el-button class="btn-item border-btn" @click="snycConvert" type="primary" :loading="issnyc"
          ><svg-icon v-show="!issnyc" iconClass="tb" className="icon"></svg-icon>{{ issnyc ? "同步中" : "同步" }}</el-button
        >
      </div>
      <div class="table-wrap">
        <el-table :data="tableList" style="width: 100%" height="calc(100vh - 290px)">
          <el-table-column prop="advertiserName" label="广告账户"></el-table-column>
          <el-table-column prop="name" label="转化归因"></el-table-column>
          <el-table-column prop="convertId" label="转化ID"></el-table-column>
          <el-table-column prop="convertSourceType" label="上报方式">
            <template slot-scope="scope">
              {{ accessTypeList.find((item) => item.value === scope.row.convertSourceType).label }}
            </template>
          </el-table-column>
          <el-table-column prop="claimType" label="归因方式">
            <template slot-scope="scope">
              {{ claimTypeList.find((item) => item.value === scope.row.claimType).label }}
            </template>
          </el-table-column>

          <el-table-column prop="convertType" label="优化目标类型">
            <template slot-scope="scope">
              {{ transferActionList.find((item) => item.value === scope.row.convertType).label }}
            </template>
          </el-table-column>
          <el-table-column prop="deepExternalAction" label="深度转化目标">
            <template slot-scope="scope">
              <span v-if="scope.row.deepExternalAction">
                {{ transferActionList.find((item) => item.value === scope.row.deepExternalAction).label }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="接入状态">
            <template slot-scope="scope">
              {{ accessStatusList.find((item) => item.value === scope.row.status).label }}
            </template>
          </el-table-column>
          <el-table-column prop="del" label="是否已删除">
            <template slot-scope="scope">
              {{ scope.row.del ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <el-button type="text" @click="checkTransform(scope.row)">详情</el-button>
              <el-button v-if="scope.row.status !== 'ACCESS_STATUS_PENDING'" type="text" @click="push(scope.row)">授权</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pro-pagination-wrap">
          <self-pagination
            :total="pageData.total"
            :pageSize="pageData.size"
            :currentPage="pageData.page"
            @getCurrentPage="changePage"
            @handleSizeChange="changePageSize"
          ></self-pagination>
        </div>
      </div>
    </div>
    <edit-modal @refreshList="searchData" ref="editModalRef"></edit-modal>
    <push-modal @successCallBack="pushSucessCall" ref="pushModalRef"></push-modal>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import { getAdCount, getConvert_gdt, snycConvertData_gdt } from "@/api/property.js";
import EditModal from "./sub/editModal.vue";
import PushModal from "./sub/push.vue";
import { accessTypeList, claimTypeList, accessStatusList } from "./sub/config";
import { transferActionList } from "../../../promotion-gdt/subPlan/common/config";
export default {
  name: "property",
  components: {
    SvgIcon,
    EditModal,
    PushModal,
  },
  data() {
    return {
      accessTypeList,
      claimTypeList,
      transferActionList,
      accessStatusList,
      countList: [],
      copyCountList: [],
      tableList: [],
      filterData: {
        advertiserIds: -1,
        status: -1,
        search: "",
      },
      pageData: {
        page: 1,
        size: 10,
        total: 15,
      },
      issnyc: false, //是否同步中
    };
  },
  mounted() {
    this.initSelect();
    this.searchData();
  },
  methods: {
    initSelect() {
      getAdCount({ platType: 2 }).then((res) => {
        if (res.code === "0000") {
          this.countList = res.advertiseInfos;
          this.copyCountList = JSON.parse(JSON.stringify(res.advertiseInfos));
        }
      });
    },
    formatParmas() {
      let parmas = {
        pageNum: this.pageData.page,
        pageSize: this.pageData.size,
        platType: 2,
      };
      for (let [key, value] of Object.entries(this.filterData)) {
        if (value !== -1 && value !== "") {
          parmas[key] = value;
        }
      }
      return parmas;
    },
    searchData() {
      let parmas = this.formatParmas();
      getConvert_gdt(parmas).then((res) => {
        if (res.code === "0000") {
          this.tableList = res.data.list;
          this.pageData.total = res.data.total;
        }
      });
    },
    resetFilter() {
      this.filterData.advertiserIds = -1;
      this.filterData.status = -1;
      this.filterData.search = "";
      this.searchData();
    },
    changePage(page) {
      this.pageData.page = page;
      this.searchData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.searchData();
    },
    addTransform() {
      this.$refs.editModalRef.addTransform();
    },
    checkTransform(data) {
      this.$refs.editModalRef.checkTransform(data);
    },
    push(data) {
      this.$refs.pushModalRef.showTransferModal(data);
    },
    snycConvert() {
      this.issnyc = true;
      let parmas = {};
      if (this.filterData.advertiserIds !== -1) {
        parmas.advertiserIds = this.filterData.advertiserIds;
      }
      snycConvertData_gdt(parmas).then((res) => {
        if (res.code === "0000") {
          this.issnyc = false;
          this.$message({
            message: "转化数据同步成功",
            type: "success",
          });
          this.searchData();
        }
      });
    },
    filterCount(value) {
      if (value) {
        this.countList = this.copyCountList.filter((item) => {
          return (
            (item.advertiserId + "").toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            (item.advertiserName + "").toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            (item.company + "").toLowerCase().indexOf(value.toLowerCase()) >= 0
          );
        });
      } else {
        this.countList = this.copyCountList;
      }
    },
    pushSucessCall() {
      console.log("授权成功");
    },
  },
};
</script>

<style lang="less" scoped>
.property-wrap {
  padding: 16px;
  .page-header {
    display: flex;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    .select-item {
      margin-right: 24px;
    }
    .header-btn {
      padding: 5px 22px;
    }
  }
  .page-content {
    margin-top: 16px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    .btn-list {
      display: flex;
      .btn-item {
        padding: 5px 18px;
        .icon {
          margin-right: 6px;
        }
        &.border-btn {
          color: rgba(24, 144, 255, 1);
          border-radius: 2px;
          border: 1px solid rgba(24, 144, 255, 1);
          background: rgba(255, 255, 255, 1);
        }
        .rotate {
          transition: rotating 2s linear infinite !important;
        }
      }
    }
    .table-wrap {
      margin-top: 16px;
      min-height: 300px;
      .pro-pagination-wrap {
        height: 58px;
      }
    }
  }
}
</style>
